export enum BabaYagaFeatureFlags {
    DrugScreenTestCodesMaxCount = 'DrugScreenTestCodesMaxCount',
    ComplianceInAppNotifications = 'ComplianceInAppNotifications',
    DisableSFTPSterlingStatus = 'DisableSFTPSterlingStatus',
    MentionsFilter = 'MentionsFilter',
    AbilityToMentionUserInLabRequest = 'AbilityToMentionUserInLabRequest',
    hdsRefactoring = 'hds-refactoring',
    BackgroundCheckShowPackageDetails = 'show-bgc-package-details',
    BackgroundCheckNonSterlingOrders = 'BackgroundCheckNonSterlingOrders',
    AddPendingInternalDocuments = 'add-pending-internal-documents',
    LabTicketsUseNewComplianceReportEndpoint = 'LabTicketsUseNewComplianceReportEndpoint',
    LabDSCheckbox = 'LabDSCheckbox',
    SterlingAccounts = 'sterling-accounts',
    CreateBackgroundCheckOrderByCandidate = 'create-bgc-order-by-candidate',
    SubmittedPackageDetails = 'submitted-package-details',
    FilterAyaStatuses = 'filter-aya-statuses',
    BackgroundCheckAliases = 'background-check-aliases',
    NursysItemStatusColumn = 'nursys-item-status-column',
    ShowNursysGridNotes = 'show-nursys-grid-notes',
    BackgroundCheckAttachments = 'background-check-attachments',
    DisplayAddedViaSterlingPortal = 'display-added-via-sterling-portal',
    DisableNewPackagesFunctionality = 'bgc-disable-new-packages-functionality',
    DisplayIntegrationResults = 'display-integration-results',
    AllowLabTicketResubmission = 'allow-lab-ticket-resubmission'
}
